<!-- Barra de navegación -->
<!-- <app-header *ngIf="!ocultarNavbar" [statusSearch]="statusSearch"></app-header> -->

<app-navbar *ngIf="!ocultarNavbar"></app-navbar>


<div class="container-fluid contenedor">
  <router-outlet></router-outlet>
</div>

<app-footer *ngIf="!ocultarFooter"></app-footer>

<style>
  .contenedor {
    min-height: calc(100vh - 520px);
    background-color: var(--cm-color-0);
  }
</style>